import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import text from "../styles/typography.module.scss"
import PriceBox from "../components/PriceBox"
import Getstarted from "../components/GetStarted"
import Subhero from "../components/subhero"
import PriceSlider from "../components/PriceSlider"

import "../styles/pricing.scss"

export default () => (
  <Layout>
    <SEO 
      title={"Pricing and Business plans"}
      description={"Never spend time transcribing your meeting minutes again. With our competitive prices and multilanguage plugin, you can now enjoy your automaticly transcribed meeting minutes."}
    />
    <Subhero>
      <h1 className={text.heading1}>Check your price</h1>
      <p className={text.paragraph} style={{ marginBottom: "24px" }}>
        Minutscript is a pay-per-use platform. <br />
        We also offer subscriptions with a fixed amount of meetings
      </p>
      <PriceSlider />
    </Subhero>
    <section id="plans" class="businessPlans">
      <h2 className={text.heading2}>Business Plans</h2>
      <p className={text.paragraph}>
        Here you can see an overview of our business plans. <br></br> Paying
        yearly will give you a small discount.
      </p>

      <div class="planGrid">
        <PriceBox
          feather={"users"}
          title={"10 users"}
          text={"10 meeting minuts for 10 uniqe users"}
          monthly={"533 €"}
          yearly={"6.340 €"}
        />
        <PriceBox
          feather={"home"}
          title={"20 users"}
          text={"10 meeting minuts for 20 uniqe users"}
          monthly={"1.021 €"}
          yearly={"12.130 €"}
        />
        <PriceBox
          feather={"briefcase"}
          title={"50 users"}
          text={"10 meeting minuts for 50 uniqe users"}
          monthly={"2.408 €"}
          yearly={"27.986 €"}
        />
        <PriceBox
          feather={"layers"}
          title={"Enterprise"}
          text={
            "Get a custom plan that suits your company's specific requirements.\n\nGet in touch with our sales team and we’ll develop a custom plan for your company."
          }
          contact={true}
        />
      </div>
    </section>

    <section>
      <Getstarted />
    </section>
  </Layout>
)
